import {Brick, ErrorFlow, registerBrick} from 'olympe';

/**
 * This brick will take the result we receive from the Olympe Gateway and create an array of tax code
 */
export default class ConvertTaxCodeResultFromAutomationToArray extends Brick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {string} result
     * @param {function(*)} setTaxCodesArray
     * @param {function(ErrorFlow)} setErrorFlow
     */
    update($, [result], [setTaxCodesArray, setErrorFlow]) {
        if (result === '[]') {
            setTaxCodesArray([]);
            return;
        }

        try {
            setTaxCodesArray(JSON.parse(result).filter((value, index, self) => // Remove duplicates
                index === self.findIndex((t) => {
                    return t.mwskz === value.mwskz;
                },
                ),
            ).map((taxCode) => taxCode.mwskz));
        } catch (e) {
            setErrorFlow(ErrorFlow.create('Cannot convert tax code' + e, 1000));
        }
    }
}

registerBrick('0189b6ece7a0ba3c8af9', ConvertTaxCodeResultFromAutomationToArray);
